import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, uniq} from "lodash"

import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import withRewardOnChange from "./withRewardOnChange"

const PROPERTY = "keywords"

export const schema = (required = false) =>
  Validation.array(required ? "This field is required" : null).of(
    Validation.object().shape({
      value: Validation.string().matches(
        /^[a-z\u0100–\u017F\u0180-\u024F\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF ]*$/iu,
        "Must contain only letters and spaces"
      )
    })
  )

class Keywords extends Component {
  handleChange = (values) => {
    this.props.onChange(this.props.reward, PROPERTY, values.length > 0 ? uniq(values.map((reward) => reward.value.toLowerCase())) : null)
  }

  render() {
    const {reward, label, required, ...props} = this.props
    const property = get(reward, PROPERTY, null) || []
    const options = property.map((keyword) => {
      return {label: keyword, value: keyword}
    })

    return (
      <Select
        {...props}
        isMulti
        isCreatable
        name={PROPERTY}
        id={id(PROPERTY, props)}
        value={options}
        onChange={this.handleChange}
        label={`${label}${required ? "*" : ""}`}
        validation={schema(required)} />
    )
  }
}

Keywords.propTypes = {
  reward: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool
}

Keywords.defaultProps = {
  id: "keywords",
  label: "",
  required: false,
  hint: `Start typing to create new options - hit Enter or
   type a comma to add multiple options. Can be letters and spaces.`,
  allowPaste: true,
  isClearable: false
}

export default withRewardOnChange(Keywords)
